<div class="modal-recap" role="dialog" aria-labelledby="modal-title" aria-modal="true">
  <div class="modal-title">
    <div class="modal-title_request">
      @if(svgIcon) {
        <mat-icon class="icon-xl" [svgIcon]="svgIcon" aria-hidden="true"></mat-icon>
      }
      <h1 id="modal-title" class="heading-s">
        {{ title }}
      </h1>
    </div>
    @if (closeButton) {
      <mat-icon
        class="icon-m icon-close"
        (click)="closeModal()"
        aria-label="Close modal"
        tabindex="0"
        role="button">
        close
      </mat-icon>
    }
  </div>
  <div class="modal-recap-content">
    @if (description) {
      <p class="body-l">
        {{ description }}
      </p>
    }
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="modal-recap-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
